export * as Dashboard from './dashboard';
export * as LoanTransactions from './loan_transactions';

import { apiClient } from '~/api/client';
import { LoanOfficerJSONAPI } from '~/api/resources/loan_officer';

type ShowParams = {
  nmls: string;
  period?: Period;
};

export type ShowResponse = {
  data: LoanOfficerJSONAPI;
  error?: string;
};

export const show = async ({ nmls, period }: ShowParams) =>
  apiClient.get<ShowResponse>(`/loan_officers/${nmls}`, { params: { period: period } });
